import apiClient from './client';

export interface LoginRequest {
  email: string;
  password: string;
  mfaCode?: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  mfaRequired?: boolean;
}

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/auth/login', data),

  refresh: (refreshToken: string) =>
    apiClient.post<LoginResponse>('/auth/refresh', { refreshToken }),

  logout: (refreshToken: string) =>
    apiClient.post('/auth/logout', { refreshToken }),

  setupMfa: () =>
    apiClient.post<{ qrCodeUrl: string; secret: string }>('/auth/mfa/setup'),

  verifyMfa: (code: string) =>
    apiClient.post('/auth/mfa/verify', { code }),
};
